import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SelectedBudgettypeReducer(state = initialState.selectedBudgettypes, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_BUDGETTYPES_SUCCESS:
      return action.selectedBudgettypes;
    default:
      return state;
  }
}
